import { createContext, useContext } from "react";

export const UserContext = createContext(null);

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within UserContext.Provider");
  }
  return context;
}

export const DataContext = createContext(null);

export function useDataContext() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useDataContext must be used within DataContext.Provider");
  }
  return context;
}
